export default "__VITE_ASSET__0baee25b__"